import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { currentLanguage } from "../../i18n";
import Header from "../../components/Header/Header";
import FooterSection from "../../components/FooterSection/FooterSection";

const PDF_URL = "/documents/siteuyesiaydinlatma.pdf";

const KvkkPage: React.FC = () => {
  const location = useLocation();

  const solutionsRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const pressRef = useRef<HTMLDivElement>(null);
  const testimonialRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentHash = location.hash;

    if (!currentPath.match(/^\/[a-z]{2}(\/|$)/)) {
      const newPath = `/${currentLanguage}${currentPath === "/" ? "" : currentPath}${currentHash}`;
      window.history.replaceState(null, "", newPath);
    }
  }, [location.pathname, location.hash]);

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isMobile) {
    window.open(PDF_URL, "_blank", "noopener,noreferrer");
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 flex flex-col bg-gray-50">
        <div className="flex-1 w-full" style={{ minHeight: "80vh" }}>
          <iframe
            src={PDF_URL}
            width="100%"
            height="100%"
            style={{ border: "none", minHeight: "80vh", display: "block" }}
            title="Site Üyesi Aydınlatma Metni"
          />
        </div>
      </main>
      <FooterSection
        missionRef={missionRef}
        pressRef={pressRef}
        testimonialRef={testimonialRef}
        blogRef={blogRef}
        showcaseRef={showcaseRef}
        solutionsRef={solutionsRef}
        contactRef={contactRef}
      />
    </div>
  );
};

export default KvkkPage;
